import primaryButton from '../../../../primary-button';

const custom = (params) => primaryButton.brandedSolid.background.disabled.custom(params);

export default custom;
